import { useMemo, FC, useState } from 'react';
import { Column, CellProps } from 'react-table';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { getDate } from 'utils/convertString';
import { PAGE_SIZE, Table } from 'components/Core/Table';
import { NoDataComponent } from 'components/Core/NoData/NoData';
import { AvatarIcon } from 'components/Core/AvatarIcon';
import { TableActionsButtons } from 'components/RequestsComponents/TableActionsButtons';
import RequestsTableFiltersForm from 'components/RequestsComponents/RequestsTableFiltersForm';
import { IBrandRequest } from 'stores/requests/types';
import { brandsRequestsTableTranslations } from './translations';
import { BrandsRequestsTableTransFields } from './types';
import styles from './brandsRequestsTable.module.scss';
import { useNavigate } from 'react-router';

export const BrandsRequestsTable: FC = observer(() => {
  const {
    requestsStore: { brandRequests },
  } = useStore();

  const { t } = useMyTranslations<BrandsRequestsTableTransFields>([brandsRequestsTableTranslations.name]);
  const navigate = useNavigate();

  const [filtred, setFiltred] = useState<IBrandRequest[]>([]);

  const columns: Column<IBrandRequest>[] = useMemo(
    () => [
      {
        Header: t('name'),
        id: 'name',
        Cell: ({
          row: {
            original: { name, logoUrl, id },
          },
        }: CellProps<IBrandRequest>) => {
          return (
            <div className={styles.avatar} onClick={() => navigate(`${id}`)}>
              <AvatarIcon avatar={logoUrl} name='logoUrl' size={56} styleProps={{ borderRadius: 8 }} />
              <p className={styles.name}>{name}</p>
            </div>
          );
        },
        accessor: ({ name }) => name,
        width: 1,
        // disableSortBy: true,
      },
      {
        Header: t('date'),
        id: 'date',
        Cell: ({
          row: {
            original: { createdAt },
          },
        }: CellProps<IBrandRequest>) => <p className={styles.name}>{getDate(createdAt)}</p>,
        accessor: ({ createdAt }) => +new Date(createdAt),
        width: 1,
        // sortType: 'apiSort',
      },
      {
        Header: t('owner'),
        id: 'owner',
        Cell: ({
          row: {
            original: {
              owner: { name, email },
            },
          },
        }: CellProps<IBrandRequest>) => {
          return (
            <div className={styles.contacts}>
              <span className={styles.contactsPhone}>{name}</span>
              <span className={styles.contactsEmail}>{email}</span>
            </div>
          );
        },
        accessor: ({ owner: { name } }) => name,
        width: 1,
        // sortType: 'apiSort',
      },
      {
        Header: t('option'),
        id: 'option',
        Cell: ({
          row: {
            original: { id, status },
          },
        }: CellProps<IBrandRequest>) => <TableActionsButtons id={id} entity='brands' status={status} />,
        width: 2,
        disableSortBy: true,
      },
    ],
    // eslint-disable-next-line
    [brandRequests]
  );

  columns.forEach((item) => (item.Filter = () => null));

  return brandRequests && brandRequests.length > 0 ? (
    <>
      <RequestsTableFiltersForm data={brandRequests} setFiltredData={setFiltred} />
      <Table columns={columns as never} data={[...filtred]} simpleList isPaginated={brandRequests.length > PAGE_SIZE} />
    </>
  ) : (
    <NoDataComponent />
  );
});
